import axios from "axios";
import { Indicator } from 'mint-ui';
export default({
    state:{
        detailData:{}
    },
    mutations:{
        newsDetail(state,id){
            Indicator.open('');  
            state.detailData={};
            var params = new URLSearchParams();
            axios.post('https://www.xiaoyu168.com/Public/SingleTradePress/'+id,params,{ headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }}).then(d=>{
                console.log(d.data)
                if(d&&d.data){ 
                    Indicator.close();
                    // console.log(d.data)
                    var data=new Date(parseInt(d.data.Datum.AddTime.replace(/[^0-9]/ig, '')))
                    d.data.Datum.AddTime2=data.format("yyyy-MM-dd")
                    state.detailData=d.data.Datum;
                }
            })
            

        }
    }
    




})


// WEBPACK FOOTER //
// ./src/store/news/detail.js